var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-5"},[_c('h5',[_vm._v(_vm._s(_vm.$t('home.missatge'))+" "+_vm._s(_vm.titleApp))])])}
var staticRenderFns = []

export { render, staticRenderFns }